const orderedKeys = ["DV", "RIESTER", "RUERUP", "PRIVAT", "UK"]
const labels = ["Direktversicherung", "Riester-Rente", "Rürup-Rente", "Private Rente", "Unterstützungskasse"]

const BERECHNUNGSVORGABEN_POINTER = "/berechnungsvorgabenFoerdervergleich"
const FOERDERVERGLEICH_POINTER = "/ergebnisFoerdervergleich"

const typeToFormaterMap = {
    object: (answer) => answer.value,
    boolean: (answer) => answer ? 100 : 0,
    number: (answer) => answer,
}

const convertAnswerToGewichtung = (answer) => typeToFormaterMap[typeof answer](answer) ?? 0

export const buildRenditeChart = (foerdervergleich, berechnungsVorgaben, updateData, target) => {
    const durchfuehrungswege = berechnungsVorgaben?.[target]?.durchfuehrungswege ?? {}
    const einzelRenditen = foerdervergleich?.[target]?.einzelRenditen ?? []

    const datasets = [{
        label: "Rendite",
        data: orderedKeys?.map(key => Number.parseFloat(einzelRenditen.find(item => item?.durchfuehrungsweg === key)?.rendite)),
        backgroundColor: orderedKeys?.map(key => durchfuehrungswege?.[key] ? "#0B2447" : "#616163"),
    }]
    const chartData = {bottomLabels: labels, topLabels: new Array(5).fill(""), datasets}
    updateData(chartData, `/av/${target}/chart`)
}

export const AltersvorsorgelueckeSchliesenActions = ({updateData, getDataFromPointer, triggerAction}) => ({
    OPEN_AKTIEN_DIALOG: () => {
        updateData(true, "/appstate/av/aktienModalOpen")
    },
    CLOSE_AKTIEN_DIALOG: () => {
        updateData(false, "/appstate/av/aktienModalOpen")
    },
    OPEN_BERECHNUNGSVORGABEN_DIALOG: () => {
        updateData(true, "/appstate/av/berechnungsvorgabenModalOpen")
    },
    CLOSE_BERECHNUNGSVORGABEN_DIALOG: () => {
        updateData(false, "/appstate/av/berechnungsvorgabenModalOpen")
    },
    INIT_LUECKE_SCHLIESEN: () => {
        // Versorgungsbilanz Kunde
        updateData("2030", "/versorgungsbilanz/kunde/jahr")
        updateData("1600.42", "/versorgungsbilanz/kunde/ziel")
        updateData("1898.00", "/versorgungsbilanz/kunde/gesetzlicheVersorgungBrutto")
        updateData("", "/versorgungsbilanz/kunde/gesetzlicheVersorgungNetto")
        updateData("0.00", "/versorgungsbilanz/kunde/betrieblicheVersorgungBruttoEuro")
        updateData("", "/versorgungsbilanz/kunde/betrieblicheVersorgungNettoEuro")
        updateData("0.00", "/versorgungsbilanz/kunde/privateVersorgungBruttoEuro")
        updateData("", "/versorgungsbilanz/kunde/privateVersorgungNettoEuro")
        updateData("0.00", "/versorgungsbilanz/kunde/summeAllerBruttoEinkuenfteEuro")
        updateData("", "/versorgungsbilanz/kunde/nettoVersorgungAusEinkuenften")
        updateData("100.00", "/versorgungsbilanz/kunde/neueVersorgungBrutto")
        updateData("1998.00", "/versorgungsbilanz/kunde/summeVersorgungUndEinkuenfteEuro")
        updateData("1440.42", "/versorgungsbilanz/kunde/nettoeinkommen")
        updateData("160.42", "/versorgungsbilanz/kunde/luecke")
        updateData("252013.31", "/versorgungsbilanz/kunde/gesamtKapitalbedarfEuro")

        // Versorgungsbilanz Ehepartner
        updateData("2030", "/versorgungsbilanz/ehepartner/jahr")
        updateData("1200.00", "/versorgungsbilanz/ehepartner/ziel")
        updateData("950.00", "/versorgungsbilanz/ehepartner/gesetzlicheVersorgungBrutto")
        updateData("", "/versorgungsbilanz/ehepartner/gesetzlicheVersorgungNetto")
        updateData("0.00", "/versorgungsbilanz/ehepartner/betrieblicheVersorgungBruttoEuro")
        updateData("", "/versorgungsbilanz/ehepartner/betrieblicheVersorgungNettoEuro")
        updateData("0.00", "/versorgungsbilanz/ehepartner/privateVersorgungBruttoEuro")
        updateData("", "/versorgungsbilanz/ehepartner/privateVersorgungNettoEuro")
        updateData("0.00", "/versorgungsbilanz/ehepartner/summeAllerBruttoEinkuenfteEuro")
        updateData("", "/versorgungsbilanz/ehepartner/nettoVersorgungAusEinkuenften")
        updateData("50.00", "/versorgungsbilanz/ehepartner/neueVersorgungBrutto")
        updateData("1000.00", "/versorgungsbilanz/ehepartner/summeVersorgungUndEinkuenfteEuro")
        updateData("820.00", "/versorgungsbilanz/ehepartner/nettoeinkommen")
        updateData("380.00", "/versorgungsbilanz/ehepartner/luecke")
        updateData("125000.00", "/versorgungsbilanz/ehepartner/gesamtKapitalbedarfEuro")
        const werte = {
            nettorente: "X,XX",
            kapital: "X.XXX,XX",
            monatlicheSparrate: "X,XX",
            rendite: "X,X",
        }
        updateData(werte, "/appstate/av/textwerte")

        const fordervergleich = getDataFromPointer(FOERDERVERGLEICH_POINTER)
        const berechnungsvorgaben = getDataFromPointer(BERECHNUNGSVORGABEN_POINTER)

        buildRenditeChart(fordervergleich, berechnungsvorgaben, updateData, "kunde")
        buildRenditeChart(fordervergleich, berechnungsvorgaben, updateData, "ehepartner")
    },
    RECALC_RENDITE_CHART: () => {
        const fordervergleich = getDataFromPointer(FOERDERVERGLEICH_POINTER)
        const berechnungsvorgaben = getDataFromPointer(BERECHNUNGSVORGABEN_POINTER)

        buildRenditeChart(fordervergleich, berechnungsvorgaben, updateData, "kunde")
        buildRenditeChart(fordervergleich, berechnungsvorgaben, updateData, "ehepartner")
    },
    SET_AV_PRAEFERENZ: ({widget, value}) => {
        const pointer = widget?.savePointer
        const praeferenzList = getDataFromPointer(pointer) ?? []

        const newPraeferenz = {
            frageId: widget.id,
            gewichtung: convertAnswerToGewichtung(value),
        }

        const newPraeferenzList = [...praeferenzList.filter(praeferenz => praeferenz?.frageId !== widget.id), newPraeferenz]
        updateData(newPraeferenzList, pointer)
        triggerAction("UPDATE_CONTEXTAREA", {contextArea: "Altersvorsorge", value: newPraeferenzList, merkmal: {pointer}})
    }
})
